<section class="px-4 sm:px-6 lg:px-12 py-6 sm:py-8 lg:py-10 bg-white">
  <article class="pb-2 bg-white max-w-full">
    <header class="w-full text-xl sm:text-2xl font-bold leading-tight text-black mb-4 sm:mb-5">
      Compatibility
    </header>

    <div class="flex flex-col gap-4 sm:gap-6 items-start w-full">
      <!-- Search Form Card -->
      <section
        *ngIf="!showVehiclePopup && !searchVehiclesdata"
        class="flex gap-3 sm:gap-4 items-center p-3 sm:p-4 w-full bg-white rounded-xl shadow-[0px_2px_12px_rgba(0,0,0,0.08)] border border-neutral-200 flex-col lg:flex-row lg:items-center"
      >
        <!-- Registration Number Field -->
        <div
          class="flex relative flex-1 flex-col w-full px-3 py-2 bg-neutral-50 lg:bg-white rounded-lg border border-neutral-200 lg:border-none focus-within:border-blue-500"
        >
          <label
            for="registrationNo"
            class="text-xs font-medium leading-4 text-neutral-600 text-left"
          >
            Registration No
          </label>
          <input
            id="registrationNo"
            [(ngModel)]="searchData.registrationNo"
            (ngModelChange)="onRegistrationNoChange(searchData.registrationNo)"
            (keydown)="preventInvalidInput($event)"
            maxlength="10"
            minlength="10"
            pattern="^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$"
            [disabled]="!!searchData.brand"
            placeholder="E.g. MH14GH9900"
            class="text-sm sm:text-base font-bold leading-6 w-full text-left placeholder:text-neutral-400 placeholder:font-normal focus:outline-none bg-transparent uppercase"
          />
        </div>

        <!-- Mobile OR Separator -->
        <div class="relative flex items-center justify-center w-full my-1 lg:hidden">
          <div class="w-full border-t border-neutral-200"></div>
          <span class="absolute bg-white px-2 py-0.5 text-xs font-semibold text-neutral-500 border border-neutral-300 rounded-full">OR</span>
        </div>

        <!-- Desktop OR Separator -->
        <div class="hidden lg:flex items-center self-stretch">
          <div class="w-px h-10 bg-neutral-200"></div>
          <span class="w-6 h-6 -ml-3 text-xs font-semibold text-neutral-500 bg-white border border-neutral-300 rounded-full flex items-center justify-center">OR</span>
        </div>

        <!-- Brand Field -->
        <div
          class="flex relative flex-1 flex-col w-full px-3 py-2 bg-neutral-50 lg:bg-white rounded-lg border border-neutral-200 lg:border-none cursor-pointer"
          #brandInput
          (click)="openDropdown()"
        >
          <label
            for="brand"
            class="text-xs font-medium leading-4 text-neutral-600 text-left cursor-pointer"
          >
            Brand
          </label>
          <div class="flex items-center justify-between w-full">
            <input
              id="brand"
              [(ngModel)]="searchData.brand"
              readonly
              autocomplete="off"
              [disabled]="!!searchData.registrationNo"
              (ngModelChange)="onBrandChange()"
              placeholder="Select Brand"
              class="text-sm sm:text-base font-bold leading-6 text-black bg-transparent border-none outline-none w-full appearance-none pr-2 text-left placeholder:text-neutral-400 placeholder:font-normal cursor-pointer"
            />
            <svg
              class="w-5 h-5 flex-shrink-0 text-neutral-700"
              [class.opacity-40]="!!searchData.registrationNo"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        <!-- Divider for desktop -->
        <div class="hidden lg:block w-px h-10 bg-neutral-200"></div>

        <!-- Model Field -->
        <div
          class="flex relative flex-1 flex-col w-full px-3 py-2 bg-neutral-50 lg:bg-white rounded-lg border border-neutral-200 lg:border-none cursor-pointer"
          #modelInput
          [class.opacity-50]="!isModelEnabled || !!searchData.registrationNo"
          [class.pointer-events-none]="!isModelEnabled || !!searchData.registrationNo"
          (click)="openDropdownmodel()"
        >
          <label
            for="model"
            class="text-xs font-medium leading-4 text-neutral-600 text-left cursor-pointer"
          >
            Model
          </label>
          <div class="flex items-center justify-between w-full">
            <input
              id="model"
              [(ngModel)]="searchData.model"
              readonly
              autocomplete="off"
              placeholder="Select Model"
              [disabled]="!isModelEnabled || !!searchData.registrationNo"
              class="text-sm sm:text-base font-bold leading-6 text-black bg-transparent border-none outline-none w-full appearance-none pr-2 text-left placeholder:text-neutral-400 placeholder:font-normal cursor-pointer"
            />
            <svg
              class="w-5 h-5 flex-shrink-0 text-neutral-700"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        <!-- Divider for desktop -->
        <div class="hidden lg:block w-px h-10 bg-neutral-200"></div>

        <!-- Year Field -->
        <div
          class="flex relative flex-1 flex-col w-full px-3 py-2 bg-neutral-50 lg:bg-white rounded-lg border border-neutral-200 lg:border-none cursor-pointer"
          (click)="toggleYearGrid()"
          [class.opacity-50]="!isYearEnabled || !!searchData.registrationNo"
          [class.pointer-events-none]="!isYearEnabled || !!searchData.registrationNo"
          #dropdownYear
        >
          <label
            class="text-xs font-medium leading-4 text-neutral-600 text-left cursor-pointer"
          >
            Year of Manufacture
          </label>
          <div class="flex items-center justify-between w-full">
            <span
              class="text-sm sm:text-base font-bold leading-6 truncate"
              [ngClass]="searchData.year ? 'text-black' : 'text-neutral-400 font-normal'"
            >
              {{ searchData.year || "Select Year" }}
            </span>
            <svg
              class="w-5 h-5 flex-shrink-0 text-neutral-700"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        <!-- Divider for desktop -->
        <div class="hidden lg:block w-px h-10 bg-neutral-200"></div>

        <!-- Variant Field -->
        <div
          class="flex relative flex-1 flex-col w-full px-3 py-2 bg-neutral-50 lg:bg-white rounded-lg border border-neutral-200 lg:border-none cursor-pointer"
          #variantInput
          [class.opacity-50]="!isVariantEnabled || !!searchData.registrationNo"
          [class.pointer-events-none]="!isVariantEnabled || !!searchData.registrationNo"
          (click)="openDropdownvariant()"
        >
          <label
            for="variant"
            class="text-xs font-medium leading-4 text-neutral-600 text-left cursor-pointer"
          >
            Variant
          </label>
          <div class="flex items-center justify-between w-full">
            <input
              id="variant"
              [(ngModel)]="searchData.variant"
              readonly
              autocomplete="off"
              placeholder="Fuel - Variant"
              [disabled]="!isVariantEnabled || !!searchData.registrationNo"
              class="text-sm sm:text-base font-bold leading-6 text-black bg-transparent border-none outline-none w-full appearance-none pr-2 text-left placeholder:text-neutral-400 placeholder:font-normal cursor-pointer"
            />
            <svg
              class="w-5 h-5 flex-shrink-0 text-neutral-700"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        <!-- Divider for desktop -->
        <div class="hidden lg:block w-px h-10 bg-neutral-200"></div>

        <!-- Desktop Search Button -->
        <button
          (click)="getVehicle()"
          [disabled]="!isButtonEnabled"
          class="hidden lg:flex justify-center items-center w-12 h-12 rounded-lg transition-colors flex-shrink-0"
          [ngClass]="{
            'bg-[#0A0A5F] text-white hover:bg-blue-900': isButtonEnabled,
            'bg-neutral-300 text-neutral-500 cursor-not-allowed': !isButtonEnabled,
          }"
          aria-label="Search"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </button>

        <!-- Mobile Search Button -->
        <button
          (click)="getVehicle()"
          [disabled]="!isButtonEnabled"
          class="w-full flex lg:hidden items-center justify-center gap-2 p-3 text-base font-bold text-center text-white rounded-lg mt-1 transition-colors"
          [ngClass]="isButtonEnabled ? 'bg-[#0A0A5F] active:bg-blue-900' : 'bg-neutral-300 text-neutral-500 cursor-not-allowed'"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <span>Search</span>
        </button>
      </section>

      <!-- Matched State Card (Compatible) -->
      <div
        class="w-full p-4 sm:p-5 bg-white rounded-xl border border-neutral-200 shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4"
        *ngIf="searchVehiclesdata"
      >
        <div class="flex items-center gap-4">
          <!-- Vehicle Image -->
          <img
            [src]="vehicleImage"
            alt="Vehicle"
            class="w-20 h-16 sm:w-28 sm:h-20 object-contain flex-shrink-0 rounded-lg bg-neutral-50 p-1 border border-neutral-100"
          />

          <!-- Compatibility Info -->
          <div class="flex flex-col gap-1 min-w-0">
            <div class="flex items-start sm:items-center gap-1.5">
              <!-- Green Check Icon -->
              <svg class="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5 sm:mt-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span class="text-emerald-700 text-sm sm:text-base font-bold leading-snug">
                Compatible with {{ vehicleDetails.VEHICLE_MAKE_s }}, {{ vehicleDetails.PARENT_MODEL_s }}
              </span>
            </div>

            <div class="text-neutral-800 text-xs sm:text-sm font-semibold pl-6">
              {{ vehicleDetails.YEAR_OF_MANUFACTURE_s }}
            </div>

            <div
              class="text-blue-600 text-xs sm:text-sm font-bold cursor-pointer hover:underline pl-6"
              (click)="handleConfirm()"
            >
              View related parts
            </div>
          </div>
        </div>

        <!-- Change Button -->
        <button
          (click)="changeVehicle()"
          class="w-full md:w-auto px-6 py-2.5 rounded-lg border border-blue-900 text-blue-900 font-bold text-sm sm:text-base hover:bg-blue-50 transition-colors"
        >
          Change
        </button>
      </div>

      <!-- Not Compatible State Card -->
      <div
        class="w-full p-4 sm:p-5 bg-white rounded-xl border border-red-200 shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4"
        *ngIf="!searchVehiclesdata && showVehiclePopup"
      >
        <div class="flex items-center gap-3">
          <svg class="w-6 h-6 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <span class="text-red-600 text-sm sm:text-base font-bold leading-snug">
            <ng-container *ngIf="!isregistrationNoValid">
              Not Compatible with {{ searchData.registrationNo }}
            </ng-container>
            <ng-container *ngIf="isregistrationNoValid">
              Not Compatible with {{ searchData.brand }} {{ searchData.model }}
            </ng-container>
          </span>
        </div>

        <button
          (click)="changeVehicle()"
          class="w-full md:w-auto px-6 py-2.5 rounded-lg border border-blue-900 text-blue-900 font-bold text-sm sm:text-base hover:bg-blue-50 transition-colors"
        >
          Try Another Vehicle
        </button>
      </div>
    </div>

    <!-- Other Compatible Vehicles Section (Categorized by Brand Tabs as in Figma) -->
    <section class="mt-8 w-full font-sans">
      <h3 class="text-lg font-bold text-black mb-3">
        Other Compatible vehicles
      </h3>

      <!-- Brand Category Tabs -->
      <div class="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide border-b border-neutral-200 mb-4">
        <button
          *ngFor="let brand of otherCompatibleBrands"
          (click)="selectCompatibleBrand(brand.name)"
          class="px-4 py-2 text-sm font-bold whitespace-nowrap rounded-t-lg transition-colors border-b-2"
          [ngClass]="activeBrand === brand.name ? 'text-blue-600 border-blue-600 bg-blue-50/50' : 'text-neutral-500 border-transparent hover:text-black'"
        >
          {{ brand.name }} <span *ngIf="brand.count > 0" class="text-xs opacity-75">({{ brand.count }})</span>
        </button>
      </div>

      <!-- Mobile Cards View (Visible on mobile screens) -->
      <div class="flex flex-col gap-2.5 md:hidden w-full">
        <div
          *ngFor="let vehicle of compatibleVehicles"
          class="p-3.5 bg-neutral-50 rounded-xl border border-neutral-200 flex items-center justify-between gap-3 shadow-xs"
        >
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-bold text-black truncate">{{ vehicle.model }}</span>
            <span class="text-xs text-neutral-500 mt-0.5">{{ vehicle.year }}</span>
            <span class="text-xs text-neutral-600 mt-0.5" *ngIf="vehicle.engine?.capacity">
              {{ vehicle.engine.capacity }} {{ vehicle.engine.type }} • {{ vehicle.fuelType }}
            </span>
          </div>
          <button
            (click)="viewRelatedParts(vehicle)"
            class="px-3.5 py-1.5 text-xs font-bold text-blue-600 bg-white border border-blue-600 rounded-lg hover:bg-blue-50 whitespace-nowrap flex-shrink-0"
          >
            View Parts
          </button>
        </div>
      </div>

      <!-- Desktop Table View (Hidden on mobile screens) -->
      <div class="hidden md:block w-full overflow-hidden rounded-xl border border-neutral-200">
        <table class="w-full text-left text-sm">
          <thead class="bg-neutral-100 text-xs font-bold text-neutral-700 uppercase border-b border-neutral-200">
            <tr>
              <th class="px-4 py-3">Model</th>
              <th class="px-4 py-3">Year</th>
              <th class="px-4 py-3">Engine</th>
              <th class="px-4 py-3">Power(hp)</th>
              <th class="px-4 py-3">Fuel Type</th>
              <th class="px-4 py-3 text-right">Action</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-neutral-200 bg-white">
            <tr *ngFor="let vehicle of compatibleVehicles" class="hover:bg-neutral-50 transition-colors">
              <td class="px-4 py-3 font-semibold text-black">{{ vehicle.model }}</td>
              <td class="px-4 py-3 text-neutral-600">{{ vehicle.year }}</td>
              <td class="px-4 py-3 text-neutral-600">{{ vehicle.engine?.capacity }} {{ vehicle.engine?.type }}</td>
              <td class="px-4 py-3 text-neutral-600">{{ vehicle.power }}</td>
              <td class="px-4 py-3 text-neutral-600">{{ vehicle.fuelType }}</td>
              <td class="px-4 py-3 text-right">
                <button
                  (click)="viewRelatedParts(vehicle)"
                  class="px-3 py-1 text-xs font-bold text-blue-600 rounded-lg hover:bg-blue-50"
                >
                  View Parts
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </article>
</section>

<!-- Mobile Backdrop when any dropdown is visible -->
<div
  *ngIf="dropdownVisible || dropdownVisiblemodel || dropdownVisibleYear || dropdownVisiblevariant"
  class="fixed inset-0 bg-black/40 backdrop-blur-[1px] z-[100] lg:hidden"
  (click)="closeAllDropdowns()"
></div>

<!-- Year Dropdown -->
<section
  *ngIf="dropdownVisibleYear"
  #dropdownContainerYear
  class="slide-top-bottom z-[105] bg-white rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] p-4 year-dropdown lg:absolute lg:mt-[-40px] lg:left-[55%] lg:w-96"
>
  <!-- Mobile Header -->
  <div class="flex items-center justify-between pb-3 mb-3 border-b border-neutral-200 lg:hidden">
    <h3 class="text-base font-bold text-black">Select Year of Manufacture</h3>
    <button (click)="closeAllDropdowns()" class="p-1 text-neutral-400 hover:text-black">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <div
    class="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-3 gap-2 overflow-y-auto pr-1 max-h-60 sm:max-h-72 lg:h-48 scrollbar-hide"
  >
    <div
      *ngFor="let year of years"
      (click)="selectYear(year)"
      class="h-10 flex items-center justify-center text-center text-black text-sm sm:text-base font-bold cursor-pointer hover:bg-blue-50 hover:text-blue-600 rounded-lg border border-neutral-100 transition-colors"
      [class.bg-blue-50]="searchData.year === year"
      [class.text-blue-600]="searchData.year === year"
      [class.border-blue-300]="searchData.year === year"
    >
      {{ year }}
    </div>
  </div>
</section>

<!-- Brand Dropdown -->
<section
  *ngIf="dropdownVisible"
  #dropdownContainer
  class="slide-top-bottom z-[105] p-4 bg-white rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] brand-dropdown lg:absolute lg:p-4 lg:max-w-none lg:mt-[-40px] lg:mr-[309px] lg:ml-[350px]"
>
  <!-- Mobile Header -->
  <div class="flex items-center justify-between pb-3 mb-3 border-b border-neutral-200 lg:hidden">
    <h3 class="text-base font-bold text-black">Select Brand</h3>
    <button (click)="closeAllDropdowns()" class="p-1 text-neutral-400 hover:text-black">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <section class="flex flex-col w-full text-center">
    <h2 class="self-start text-xs sm:text-sm font-semibold text-neutral-500 mb-2">
      Popular Brands
    </h2>
    <div
      class="flex overflow-x-auto gap-4 items-center pb-2 w-full text-sm sm:text-base font-bold text-black scrollbar-hide"
    >
      <article
        *ngFor="let brand of getPopularBrands(searchData.brand)"
        class="flex flex-col items-center gap-1.5 p-2 rounded-lg hover:bg-neutral-50 cursor-pointer flex-shrink-0"
        (click)="selectBrand(brand.name)"
      >
        <img
          [src]="brand.imageUrl"
          class="object-contain w-10 h-10 rounded-md"
          alt="{{ brand.name }} logo"
        />
        <span class="text-xs font-semibold text-neutral-800">{{ brand.name }}</span>
      </article>
    </div>
  </section>

  <section
    class="flex overflow-x-auto gap-4 items-start mt-3 w-full text-sm leading-none text-black scrollbar-hide border-t border-neutral-100 pt-3"
  >
    <!-- Loading State -->
    <div
      *ngIf="isLoadingBrands"
      class="flex justify-center items-center w-full py-4"
    >
      <p class="text-gray-500">Loading brands...</p>
    </div>

    <!-- No Brands State -->
    <div
      *ngIf="
        !isLoadingBrands &&
        (!filteredBrandsList || filteredBrandsList.length === 0)
      "
      class="flex justify-center items-center w-full py-4"
    >
      <p class="text-gray-500">No brands found matching your search</p>
    </div>

    <!-- Dynamic Columns -->
    <div
      *ngFor="let column of filteredBrandsList"
      class="flex flex-col items-start min-w-[120px]"
    >
      <div
        *ngFor="let section of column"
        class="flex flex-col justify-center w-full mb-3"
      >
        <h3 class="font-bold text-xs text-neutral-400 mb-1">{{ section.letter }}</h3>
        <div class="flex flex-col justify-center w-full font-medium">
          <p
            *ngFor="let brand of section.brands"
            class="py-1 text-sm font-semibold hover:text-blue-600 cursor-pointer"
            (click)="selectBrand(brand)"
          >
            {{ brand }}
          </p>
        </div>
      </div>
    </div>
  </section>
</section>

<!-- Model Dropdown -->
<section
  *ngIf="dropdownVisiblemodel"
  #dropdownContainermodel
  class="slide-top-bottom z-[105] flex flex-col overflow-hidden bg-white p-4 rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] model-dropdown lg:absolute lg:w-[600px] lg:mt-[-40px] lg:ml-[500px]"
>
  <!-- Mobile Header -->
  <div class="flex items-center justify-between pb-3 mb-3 border-b border-neutral-200 lg:hidden">
    <h3 class="text-base font-bold text-black">Select Model</h3>
    <button (click)="closeAllDropdowns()" class="p-1 text-neutral-400 hover:text-black">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <!-- Message when no brand is selected -->
  <div
    *ngIf="!searchData.brand || !isModelEnabled"
    class="flex flex-col items-center justify-center py-8 text-center"
  >
    <svg
      class="w-12 h-12 text-gray-400 mb-3"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      ></path>
    </svg>
    <h3 class="text-base font-bold text-gray-900 mb-1">Select a Brand First</h3>
    <p class="text-sm text-gray-500">Please select a brand to see available models</p>
  </div>

  <!-- Model content when brand is selected -->
  <div *ngIf="searchData.brand && isModelEnabled">
    <section class="flex flex-col w-full text-center">
      <h2
        class="self-start text-xs sm:text-sm font-semibold text-neutral-500 mb-2"
      >
        Popular Models
      </h2>
      <div
        class="flex overflow-x-auto gap-4 items-center pb-2 w-full text-base font-bold text-black scrollbar-hide"
        *ngIf="modelimages && modelimages?.length > 0"
      >
        <article
          *ngFor="let model of modelimages"
          class="flex flex-col items-center gap-1.5 p-2 rounded-lg hover:bg-neutral-50 cursor-pointer flex-shrink-0"
          (click)="selectModel(model?.model)"
        >
          <img
            [src]="model?.image_path"
            class="object-contain w-10 h-10 rounded-md"
            alt="{{ model?.model }}"
          />
          <span class="text-xs font-semibold text-neutral-800">{{ model?.model }}</span>
        </article>
      </div>
    </section>

    <section class="mt-3 max-h-[300px] overflow-y-auto border-t border-neutral-100 pt-3">
      <!-- Loading State -->
      <div
        *ngIf="!selectedBrandmodelList || selectedBrandmodelList.length === 0"
        class="flex justify-center items-center w-full py-4"
      >
        <p class="text-sm text-gray-500">No models available for selected brand</p>
      </div>

      <!-- Brand Categories with Models -->
      <div class="grid grid-cols-2 sm:grid-cols-3 gap-4">
        <div
          *ngFor="let group of selectedBrandmodelList"
          class="flex flex-col gap-1"
        >
          <h4 class="text-xs font-bold text-neutral-400 mb-1">{{ group.letter }}</h4>
          <div class="flex flex-col gap-1">
            <p
              *ngFor="let model of group.models"
              class="text-sm text-neutral-800 cursor-pointer hover:text-blue-600 font-semibold py-1 rounded hover:bg-neutral-50"
              (click)="selectModel(model)"
            >
              {{ model }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>

<!-- Variant Dropdown -->
<section
  *ngIf="dropdownVisiblevariant"
  #dropdownContainervariant
  class="slide-top-bottom z-[105] flex flex-col overflow-hidden bg-white p-4 rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] variant-dropdown lg:absolute lg:w-[340px] lg:mt-[-40px] lg:ml-[600px]"
>
  <!-- Mobile Header -->
  <div class="flex items-center justify-between pb-3 mb-3 border-b border-neutral-200 lg:hidden">
    <h3 class="text-base font-bold text-black">Select Fuel & Variant</h3>
    <button (click)="closeAllDropdowns()" class="p-1 text-neutral-400 hover:text-black">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <div class="w-full flex flex-col gap-3">
    <!-- Fuel Type Section -->
    <div class="flex flex-col gap-1.5">
      <div class="text-xs font-semibold text-neutral-500">
        Fuel Type
      </div>
      <div class="flex flex-wrap gap-2">
        <div
          *ngFor="let fuelType of fuelTypes"
          class="px-3 py-1.5 rounded-full text-xs font-bold cursor-pointer transition-colors border"
          [ngClass]="selectedFuelType === fuelType ? 'bg-blue-600 text-white border-blue-600' : 'bg-neutral-100 text-neutral-700 border-neutral-200 hover:bg-neutral-200'"
          (click)="selectFuelType(fuelType)"
        >
          {{ fuelType }}
        </div>
      </div>
    </div>

    <!-- Variants Section -->
    <div class="flex flex-col gap-1.5 mt-2 border-t border-neutral-100 pt-3">
      <div class="text-xs font-semibold text-neutral-500">
        Variants
      </div>
      <div class="flex flex-col gap-1 max-h-[220px] overflow-y-auto">
        <div
          *ngIf="variantData.variants.length === 0"
          class="text-neutral-500 text-sm py-2"
        >
          No variants available for the selected model
        </div>
        <div
          *ngFor="let variant of variantData.variants"
          class="text-sm font-semibold text-neutral-800 cursor-pointer hover:text-blue-600 hover:bg-neutral-50 px-2 py-1.5 rounded-md transition-colors"
          (click)="selectVariantFromDropdown(variant)"
        >
          {{ variant }}
        </div>
      </div>
    </div>
  </div>
</section>

